export default "__VITE_ASSET__dfdd3bec__"